<template>
  <!-- Pass through any attrs like class, width, height, etc. -->
  <component
    :is="iconComponent"
    v-bind="svgProps"
    :class="[attrs.class || 'h-4 w-4', { 'cursor-pointer': cursorPointer }]"
  />
</template>

<script setup>
import { defineAsyncComponent, computed, useAttrs } from 'vue';

// Props: "icon" (icon filename without .svg)
const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  strokeWidth: {
    type: [String, Number],
    default: 2,
  },
  cursorPointer: {
    type: Boolean,
    default: true,
  },
});
const attrs = useAttrs();

// Merge attrs with strokeWidth (exclude class - we handle it in template)
const svgProps = computed(() => {
  const { ...rest } = attrs;
  const mergedProps = { ...rest };

  if (props.strokeWidth) {
    mergedProps['stroke-width'] = props.strokeWidth;
  }

  return mergedProps;
});

// Dynamically import the SVG as a Vue component using vite-svg-loader
const iconComponent = computed(() =>
  defineAsyncComponent(() => import(`@/assets/svg/${props.icon}.svg`))
);
</script>

<!-- Just an aside because we may run into in the future: SVG gradients use IDs to
reference them, and the IDs must be unique across the entire DOM. So if we want
an icon with a gradient to show up in two places, the IDs must be unique as
well.

We ran into this with the fire icon, and we use v-if there to get the
expanded one off the dom for the collapsed one to show up -->
